import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'

import styles from './styles'

const useStyles = makeStyles(styles)

const Jobs: React.FunctionComponent<any> = () => {
	const classes = useStyles()

	return (
		<Grid
			className={classes.companyJobsRoot}
			container={true}
			direction="column"
			spacing={1}
		>
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					margin: '20px',
					color: '#000000',
					fontWeight: 'bold',
					fontSize: '25px',
				}}
			>
				{'Work in progress.'}
			</div>
		</Grid>
	)
}
export default memo(Jobs)
